// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"628":"fe5ec1b3","1809":"fe5ec1b3","3351":"fe5ec1b3","5732":"fe5ec1b3","7727":"d9cd25b7","8352":"fe5ec1b3"}[chunkId] + ".chunk.css";
};